import type {
  ProductType,
  PurchaseWebContract,
} from '@xing-com/crate-common-graphql-types';

type MembershipTrackingContract = Pick<PurchaseWebContract, 'id'> & {
  price: Pick<PurchaseWebContract['price'], 'initial'>;
};

export const createMembershipProductItems = (
  product: ProductType,
  contract: MembershipTrackingContract
): string =>
  JSON.stringify([
    {
      id: `${product}_${contract.id}`,
      quantity: 1,
      price: contract.price.initial,
    },
  ]);

export const getMembershipRuntime = (
  initialDuration: PurchaseWebContract['initialDuration']
): string => `${initialDuration}_months`;
